import { getTokens } from '../../../../../auth/AuthState';
import API from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getAllActions } from '../../../../../store/ai2';

export const useUpdateActionStatus = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const location = useLocation();
  const dispatch = useDispatch();

  const postUpdateActionStatus = async (updateActionStatusPayload) => {
    setIsLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const access_token = searchParams.get('access_token');
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      const payload = {
        ...updateActionStatusPayload,
        tenancyId: selectedTenancy.tenancy_id,
        access_token,
      };
      const result = await API.post(
        `updateActionStatus`,
        { ...payload },
        options,
      );

      await dispatch(await getAllActions(access_token, selectedTenancy));
      return result;
    } catch (error) {
      console.error('An error occurred during update action status', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in update action status',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateActionStatus,
    errorMessage,
    isLoading,
  };
};
